import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AppContext";
import ImageOrArt from "../components/ImageOrArt";
import GeoArt from "../components/GeoArt";
import { MaskedLines, Reveal, SectionHead } from "../components/Reveal";

export default function Exhibitions() {
  const [exhibitions, setExhibitions] = useState([]);
  useEffect(() => {
    axios.get(`${API}/exhibitions`).then(({ data }) => setExhibitions(data)).catch(() => {});
  }, []);

  const featured = exhibitions.find((e) => e.status === "Featured");
  const archive = exhibitions.filter((e) => e.status !== "Featured");

  return (
    <main className="pt-24 sm:pt-32" data-testid="exhibitions-page">
      <section className="container-x section-y">
        <p className="eyebrow mb-6">On View & Archive</p>
        <MaskedLines lines={["Exhibitions"]} className="h-display" />
      </section>

      {featured && (
        <section className="border-t border-border" data-testid="featured-exhibition">
          <div className="container-x section-y grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <Reveal>
              <div className="border-2 border-[#FF1A1A] p-4 rotate-1 hover:rotate-0 transition-transform duration-700">
                <ImageOrArt image={featured.image} seed={featured.seed} className="w-full" />
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div>
                <p className="font-mono-x text-xs text-[#FF1A1A] uppercase tracking-[0.25em] mb-4">Featured Exhibition</p>
                <h2 className="h-display !text-5xl sm:!text-6xl mb-2" data-testid="featured-exhibition-title">{featured.title}</h2>
                <p className="font-mono-x text-sm text-muted-foreground mb-6">{featured.venue} — {featured.years}</p>
                <p className="text-muted-foreground max-w-md mb-8">{featured.description}</p>
                <div className="flex gap-2 flex-wrap">
                  <span className="font-mono-x text-[10px] uppercase tracking-widest px-2 py-1 bg-[#FF1A1A] text-white">Solo Exhibition</span>
                  <span className="font-mono-x text-[10px] uppercase tracking-widest px-2 py-1 border border-border">2025</span>
                </div>
              </div>
            </Reveal>
          </div>
        </section>
      )}

      <section className="border-t border-border">
        <div className="container-x section-y">
          <SectionHead eyebrow="Archive" title="Exhibition History" />
          <div className="relative" data-testid="exhibition-timeline">
            <div className="absolute left-4 sm:left-1/2 top-0 bottom-0 w-px bg-border" />
            <div className="space-y-12">
              {archive.map((e, i) => (
                <Reveal key={e.id} delay={0.05}>
                  <div className={`relative grid grid-cols-1 sm:grid-cols-2 gap-6 items-center ${i % 2 ? "" : ""}`} data-testid={`exhibition-item-${e.id}`}>
                    <div className="absolute left-4 sm:left-1/2 -translate-x-1/2 w-3 h-3 bg-[#FF1A1A] rotate-45" />
                    <div className={`pl-12 sm:pl-0 ${i % 2 ? "sm:order-2 sm:pl-16" : "sm:pr-16 sm:text-right"}`}>
                      <p className="font-mono-x text-xs text-[#FF1A1A] mb-2">{e.years}</p>
                      <h3 className="font-display font-extrabold uppercase text-xl sm:text-2xl">{e.title}</h3>
                      <p className="text-sm text-muted-foreground mt-1">{e.venue}</p>
                      <p className="text-sm text-muted-foreground mt-3 max-w-md sm:inline-block">{e.description}</p>
                    </div>
                    <div className={`pl-12 sm:pl-0 ${i % 2 ? "sm:order-1 sm:pr-16" : "sm:pl-16"}`}>
                      <div className="border border-border overflow-hidden max-w-xs">
                        <ImageOrArt image={e.image} seed={e.seed} ratio="16/9" className="w-full" />
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
